module.exports = __webpack_public_path__ + "media/images/custom_page/toz_event/toz-event-ko-052c1c18ee8bcd43c651d3174793e5d2.png";